import api from "./api";
import { toast } from "../components/ui/sonner";

const SCRIPT_SRC = "https://checkout.razorpay.com/v1/checkout.js";

function loadScript() {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = SCRIPT_SRC;
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}

// Opens Razorpay Checkout for a server-priced item. Resolves with the verify
// response on success, rejects with Error("cancelled") if the user closes it.
export async function payWithRazorpay(item, extra = {}) {
  const ok = await loadScript();
  if (!ok) throw new Error("gateway");
  const { data } = await api.post("/payments/razorpay/order", { item, ...extra });
  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: data.key_id,
      amount: data.amount,
      currency: data.currency,
      name: data.name,
      description: data.description,
      order_id: data.order_id,
      prefill: data.prefill,
      theme: { color: "#D95338" },
      handler: async (resp) => {
        try {
          const v = await api.post("/payments/razorpay/verify", {
            razorpay_order_id: resp.razorpay_order_id,
            razorpay_payment_id: resp.razorpay_payment_id,
            razorpay_signature: resp.razorpay_signature,
          });
          toast.success("Payment successful", { description: data.description });
          resolve(v.data);
        } catch (e) { reject(e); }
      },
      modal: { ondismiss: () => reject(new Error("cancelled")) },
    });
    rzp.open();
  });
}
